var cov_2nqpyt597g = function () {
  var path = '/opt/tomcat/.jenkins/workspace/delta-bitbucket-production/client/src/app/views/indicator/planification/indicatorPlan.js',
      hash = '519c82c9846cc53185bb07b3bd7e40fd53627796',
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/opt/tomcat/.jenkins/workspace/delta-bitbucket-production/client/src/app/views/indicator/planification/indicatorPlan.js',
    statementMap: {
      '0': {
        start: {
          line: 1,
          column: 0
        },
        end: {
          line: 192,
          column: 3
        }
      },
      '1': {
        start: {
          line: 2,
          column: 17
        },
        end: {
          line: 2,
          column: 34
        }
      },
      '2': {
        start: {
          line: 3,
          column: 20
        },
        end: {
          line: 3,
          column: 36
        }
      },
      '3': {
        start: {
          line: 4,
          column: 19
        },
        end: {
          line: 4,
          column: 67
        }
      },
      '4': {
        start: {
          line: 5,
          column: 2
        },
        end: {
          line: 8,
          column: 4
        }
      },
      '5': {
        start: {
          line: 9,
          column: 2
        },
        end: {
          line: 23,
          column: 4
        }
      },
      '6': {
        start: {
          line: 10,
          column: 4
        },
        end: {
          line: 10,
          column: 33
        }
      },
      '7': {
        start: {
          line: 11,
          column: 4
        },
        end: {
          line: 11,
          column: 31
        }
      },
      '8': {
        start: {
          line: 12,
          column: 4
        },
        end: {
          line: 12,
          column: 37
        }
      },
      '9': {
        start: {
          line: 13,
          column: 4
        },
        end: {
          line: 15,
          column: 5
        }
      },
      '10': {
        start: {
          line: 14,
          column: 6
        },
        end: {
          line: 14,
          column: 13
        }
      },
      '11': {
        start: {
          line: 16,
          column: 17
        },
        end: {
          line: 16,
          column: 54
        }
      },
      '12': {
        start: {
          line: 17,
          column: 4
        },
        end: {
          line: 19,
          column: 5
        }
      },
      '13': {
        start: {
          line: 18,
          column: 6
        },
        end: {
          line: 18,
          column: 13
        }
      },
      '14': {
        start: {
          line: 20,
          column: 4
        },
        end: {
          line: 20,
          column: 93
        }
      },
      '15': {
        start: {
          line: 21,
          column: 4
        },
        end: {
          line: 21,
          column: 68
        }
      },
      '16': {
        start: {
          line: 22,
          column: 4
        },
        end: {
          line: 22,
          column: 30
        }
      },
      '17': {
        start: {
          line: 24,
          column: 2
        },
        end: {
          line: 46,
          column: 4
        }
      },
      '18': {
        start: {
          line: 25,
          column: 4
        },
        end: {
          line: 25,
          column: 27
        }
      },
      '19': {
        start: {
          line: 26,
          column: 19
        },
        end: {
          line: 26,
          column: 55
        }
      },
      '20': {
        start: {
          line: 27,
          column: 4
        },
        end: {
          line: 29,
          column: 5
        }
      },
      '21': {
        start: {
          line: 28,
          column: 6
        },
        end: {
          line: 28,
          column: 13
        }
      },
      '22': {
        start: {
          line: 30,
          column: 4
        },
        end: {
          line: 30,
          column: 33
        }
      },
      '23': {
        start: {
          line: 31,
          column: 4
        },
        end: {
          line: 31,
          column: 28
        }
      },
      '24': {
        start: {
          line: 32,
          column: 4
        },
        end: {
          line: 45,
          column: 7
        }
      },
      '25': {
        start: {
          line: 33,
          column: 6
        },
        end: {
          line: 42,
          column: 7
        }
      },
      '26': {
        start: {
          line: 34,
          column: 8
        },
        end: {
          line: 38,
          column: 9
        }
      },
      '27': {
        start: {
          line: 35,
          column: 10
        },
        end: {
          line: 35,
          column: 45
        }
      },
      '28': {
        start: {
          line: 36,
          column: 10
        },
        end: {
          line: 36,
          column: 44
        }
      },
      '29': {
        start: {
          line: 37,
          column: 10
        },
        end: {
          line: 37,
          column: 52
        }
      },
      '30': {
        start: {
          line: 39,
          column: 8
        },
        end: {
          line: 39,
          column: 98
        }
      },
      '31': {
        start: {
          line: 40,
          column: 8
        },
        end: {
          line: 40,
          column: 29
        }
      },
      '32': {
        start: {
          line: 41,
          column: 8
        },
        end: {
          line: 41,
          column: 77
        }
      },
      '33': {
        start: {
          line: 43,
          column: 6
        },
        end: {
          line: 43,
          column: 31
        }
      },
      '34': {
        start: {
          line: 44,
          column: 6
        },
        end: {
          line: 44,
          column: 31
        }
      },
      '35': {
        start: {
          line: 47,
          column: 2
        },
        end: {
          line: 52,
          column: 4
        }
      },
      '36': {
        start: {
          line: 48,
          column: 4
        },
        end: {
          line: 48,
          column: 28
        }
      },
      '37': {
        start: {
          line: 49,
          column: 4
        },
        end: {
          line: 51,
          column: 7
        }
      },
      '38': {
        start: {
          line: 50,
          column: 6
        },
        end: {
          line: 50,
          column: 32
        }
      },
      '39': {
        start: {
          line: 53,
          column: 2
        },
        end: {
          line: 61,
          column: 4
        }
      },
      '40': {
        start: {
          line: 54,
          column: 4
        },
        end: {
          line: 54,
          column: 45
        }
      },
      '41': {
        start: {
          line: 55,
          column: 4
        },
        end: {
          line: 55,
          column: 87
        }
      },
      '42': {
        start: {
          line: 56,
          column: 4
        },
        end: {
          line: 56,
          column: 65
        }
      },
      '43': {
        start: {
          line: 57,
          column: 4
        },
        end: {
          line: 57,
          column: 61
        }
      },
      '44': {
        start: {
          line: 58,
          column: 4
        },
        end: {
          line: 58,
          column: 63
        }
      },
      '45': {
        start: {
          line: 59,
          column: 4
        },
        end: {
          line: 59,
          column: 71
        }
      },
      '46': {
        start: {
          line: 60,
          column: 4
        },
        end: {
          line: 60,
          column: 73
        }
      },
      '47': {
        start: {
          line: 62,
          column: 2
        },
        end: {
          line: 87,
          column: 4
        }
      },
      '48': {
        start: {
          line: 63,
          column: 4
        },
        end: {
          line: 63,
          column: 46
        }
      },
      '49': {
        start: {
          line: 64,
          column: 4
        },
        end: {
          line: 64,
          column: 35
        }
      },
      '50': {
        start: {
          line: 65,
          column: 4
        },
        end: {
          line: 70,
          column: 5
        }
      },
      '51': {
        start: {
          line: 66,
          column: 6
        },
        end: {
          line: 69,
          column: 7
        }
      },
      '52': {
        start: {
          line: 67,
          column: 8
        },
        end: {
          line: 67,
          column: 37
        }
      },
      '53': {
        start: {
          line: 68,
          column: 8
        },
        end: {
          line: 68,
          column: 14
        }
      },
      '54': {
        start: {
          line: 71,
          column: 4
        },
        end: {
          line: 73,
          column: 7
        }
      },
      '55': {
        start: {
          line: 72,
          column: 6
        },
        end: {
          line: 72,
          column: 39
        }
      },
      '56': {
        start: {
          line: 74,
          column: 4
        },
        end: {
          line: 76,
          column: 5
        }
      },
      '57': {
        start: {
          line: 75,
          column: 6
        },
        end: {
          line: 75,
          column: 13
        }
      },
      '58': {
        start: {
          line: 77,
          column: 4
        },
        end: {
          line: 77,
          column: 31
        }
      },
      '59': {
        start: {
          line: 78,
          column: 4
        },
        end: {
          line: 78,
          column: 35
        }
      },
      '60': {
        start: {
          line: 79,
          column: 4
        },
        end: {
          line: 79,
          column: 37
        }
      },
      '61': {
        start: {
          line: 80,
          column: 4
        },
        end: {
          line: 80,
          column: 105
        }
      },
      '62': {
        start: {
          line: 81,
          column: 4
        },
        end: {
          line: 81,
          column: 31
        }
      },
      '63': {
        start: {
          line: 82,
          column: 4
        },
        end: {
          line: 82,
          column: 27
        }
      },
      '64': {
        start: {
          line: 83,
          column: 4
        },
        end: {
          line: 83,
          column: 32
        }
      },
      '65': {
        start: {
          line: 84,
          column: 4
        },
        end: {
          line: 84,
          column: 25
        }
      },
      '66': {
        start: {
          line: 85,
          column: 4
        },
        end: {
          line: 85,
          column: 64
        }
      },
      '67': {
        start: {
          line: 86,
          column: 4
        },
        end: {
          line: 86,
          column: 28
        }
      },
      '68': {
        start: {
          line: 88,
          column: 2
        },
        end: {
          line: 156,
          column: 4
        }
      },
      '69': {
        start: {
          line: 89,
          column: 4
        },
        end: {
          line: 89,
          column: 39
        }
      },
      '70': {
        start: {
          line: 90,
          column: 4
        },
        end: {
          line: 90,
          column: 33
        }
      },
      '71': {
        start: {
          line: 91,
          column: 23
        },
        end: {
          line: 91,
          column: 25
        }
      },
      '72': {
        start: {
          line: 92,
          column: 18
        },
        end: {
          line: 92,
          column: 35
        }
      },
      '73': {
        start: {
          line: 93,
          column: 18
        },
        end: {
          line: 93,
          column: 35
        }
      },
      '74': {
        start: {
          line: 94,
          column: 4
        },
        end: {
          line: 100,
          column: 5
        }
      },
      '75': {
        start: {
          line: 95,
          column: 6
        },
        end: {
          line: 95,
          column: 43
        }
      },
      '76': {
        start: {
          line: 96,
          column: 6
        },
        end: {
          line: 96,
          column: 41
        }
      },
      '77': {
        start: {
          line: 97,
          column: 11
        },
        end: {
          line: 100,
          column: 5
        }
      },
      '78': {
        start: {
          line: 98,
          column: 6
        },
        end: {
          line: 98,
          column: 40
        }
      },
      '79': {
        start: {
          line: 99,
          column: 6
        },
        end: {
          line: 99,
          column: 40
        }
      },
      '80': {
        start: {
          line: 101,
          column: 19
        },
        end: {
          line: 101,
          column: 55
        }
      },
      '81': {
        start: {
          line: 102,
          column: 4
        },
        end: {
          line: 104,
          column: 5
        }
      },
      '82': {
        start: {
          line: 103,
          column: 6
        },
        end: {
          line: 103,
          column: 13
        }
      },
      '83': {
        start: {
          line: 105,
          column: 19
        },
        end: {
          line: 105,
          column: 87
        }
      },
      '84': {
        start: {
          line: 106,
          column: 4
        },
        end: {
          line: 115,
          column: 7
        }
      },
      '85': {
        start: {
          line: 116,
          column: 4
        },
        end: {
          line: 128,
          column: 5
        }
      },
      '86': {
        start: {
          line: 117,
          column: 17
        },
        end: {
          line: 117,
          column: 22
        }
      },
      '87': {
        start: {
          line: 118,
          column: 6
        },
        end: {
          line: 124,
          column: 7
        }
      },
      '88': {
        start: {
          line: 119,
          column: 8
        },
        end: {
          line: 123,
          column: 9
        }
      },
      '89': {
        start: {
          line: 120,
          column: 10
        },
        end: {
          line: 120,
          column: 22
        }
      },
      '90': {
        start: {
          line: 121,
          column: 10
        },
        end: {
          line: 121,
          column: 39
        }
      },
      '91': {
        start: {
          line: 122,
          column: 10
        },
        end: {
          line: 122,
          column: 16
        }
      },
      '92': {
        start: {
          line: 125,
          column: 6
        },
        end: {
          line: 127,
          column: 7
        }
      },
      '93': {
        start: {
          line: 126,
          column: 8
        },
        end: {
          line: 126,
          column: 63
        }
      },
      '94': {
        start: {
          line: 129,
          column: 4
        },
        end: {
          line: 142,
          column: 5
        }
      },
      '95': {
        start: {
          line: 130,
          column: 6
        },
        end: {
          line: 130,
          column: 24
        }
      },
      '96': {
        start: {
          line: 131,
          column: 6
        },
        end: {
          line: 138,
          column: 7
        }
      },
      '97': {
        start: {
          line: 132,
          column: 19
        },
        end: {
          line: 132,
          column: 24
        }
      },
      '98': {
        start: {
          line: 133,
          column: 8
        },
        end: {
          line: 137,
          column: 9
        }
      },
      '99': {
        start: {
          line: 134,
          column: 10
        },
        end: {
          line: 134,
          column: 39
        }
      },
      '100': {
        start: {
          line: 135,
          column: 10
        },
        end: {
          line: 135,
          column: 22
        }
      },
      '101': {
        start: {
          line: 136,
          column: 10
        },
        end: {
          line: 136,
          column: 16
        }
      },
      '102': {
        start: {
          line: 139,
          column: 6
        },
        end: {
          line: 141,
          column: 7
        }
      },
      '103': {
        start: {
          line: 140,
          column: 8
        },
        end: {
          line: 140,
          column: 67
        }
      },
      '104': {
        start: {
          line: 143,
          column: 4
        },
        end: {
          line: 146,
          column: 5
        }
      },
      '105': {
        start: {
          line: 144,
          column: 6
        },
        end: {
          line: 144,
          column: 70
        }
      },
      '106': {
        start: {
          line: 145,
          column: 6
        },
        end: {
          line: 145,
          column: 24
        }
      },
      '107': {
        start: {
          line: 147,
          column: 4
        },
        end: {
          line: 147,
          column: 43
        }
      },
      '108': {
        start: {
          line: 148,
          column: 4
        },
        end: {
          line: 155,
          column: 7
        }
      },
      '109': {
        start: {
          line: 157,
          column: 2
        },
        end: {
          line: 186,
          column: 4
        }
      },
      '110': {
        start: {
          line: 158,
          column: 4
        },
        end: {
          line: 185,
          column: 7
        }
      },
      '111': {
        start: {
          line: 170,
          column: 6
        },
        end: {
          line: 172,
          column: 7
        }
      },
      '112': {
        start: {
          line: 171,
          column: 8
        },
        end: {
          line: 171,
          column: 15
        }
      },
      '113': {
        start: {
          line: 173,
          column: 6
        },
        end: {
          line: 173,
          column: 31
        }
      },
      '114': {
        start: {
          line: 174,
          column: 6
        },
        end: {
          line: 174,
          column: 34
        }
      },
      '115': {
        start: {
          line: 175,
          column: 6
        },
        end: {
          line: 175,
          column: 27
        }
      },
      '116': {
        start: {
          line: 176,
          column: 6
        },
        end: {
          line: 176,
          column: 34
        }
      },
      '117': {
        start: {
          line: 177,
          column: 6
        },
        end: {
          line: 177,
          column: 32
        }
      },
      '118': {
        start: {
          line: 178,
          column: 6
        },
        end: {
          line: 178,
          column: 25
        }
      },
      '119': {
        start: {
          line: 179,
          column: 6
        },
        end: {
          line: 179,
          column: 28
        }
      },
      '120': {
        start: {
          line: 180,
          column: 23
        },
        end: {
          line: 180,
          column: 41
        }
      },
      '121': {
        start: {
          line: 181,
          column: 6
        },
        end: {
          line: 181,
          column: 29
        }
      },
      '122': {
        start: {
          line: 182,
          column: 6
        },
        end: {
          line: 182,
          column: 31
        }
      },
      '123': {
        start: {
          line: 183,
          column: 6
        },
        end: {
          line: 183,
          column: 119
        }
      },
      '124': {
        start: {
          line: 184,
          column: 6
        },
        end: {
          line: 184,
          column: 32
        }
      },
      '125': {
        start: {
          line: 187,
          column: 2
        },
        end: {
          line: 191,
          column: 4
        }
      },
      '126': {
        start: {
          line: 188,
          column: 4
        },
        end: {
          line: 188,
          column: 22
        }
      },
      '127': {
        start: {
          line: 189,
          column: 4
        },
        end: {
          line: 189,
          column: 33
        }
      },
      '128': {
        start: {
          line: 190,
          column: 4
        },
        end: {
          line: 190,
          column: 46
        }
      },
      '129': {
        start: {
          line: 194,
          column: 20
        },
        end: {
          line: 194,
          column: 36
        }
      },
      '130': {
        start: {
          line: 195,
          column: 2
        },
        end: {
          line: 224,
          column: 4
        }
      },
      '131': {
        start: {
          line: 196,
          column: 4
        },
        end: {
          line: 218,
          column: 5
        }
      },
      '132': {
        start: {
          line: 198,
          column: 8
        },
        end: {
          line: 200,
          column: 9
        }
      },
      '133': {
        start: {
          line: 199,
          column: 10
        },
        end: {
          line: 199,
          column: 17
        }
      },
      '134': {
        start: {
          line: 201,
          column: 8
        },
        end: {
          line: 201,
          column: 33
        }
      },
      '135': {
        start: {
          line: 202,
          column: 8
        },
        end: {
          line: 202,
          column: 35
        }
      },
      '136': {
        start: {
          line: 203,
          column: 8
        },
        end: {
          line: 203,
          column: 42
        }
      },
      '137': {
        start: {
          line: 204,
          column: 8
        },
        end: {
          line: 204,
          column: 14
        }
      },
      '138': {
        start: {
          line: 206,
          column: 8
        },
        end: {
          line: 208,
          column: 9
        }
      },
      '139': {
        start: {
          line: 207,
          column: 10
        },
        end: {
          line: 207,
          column: 17
        }
      },
      '140': {
        start: {
          line: 209,
          column: 8
        },
        end: {
          line: 209,
          column: 35
        }
      },
      '141': {
        start: {
          line: 210,
          column: 8
        },
        end: {
          line: 210,
          column: 39
        }
      },
      '142': {
        start: {
          line: 211,
          column: 8
        },
        end: {
          line: 211,
          column: 36
        }
      },
      '143': {
        start: {
          line: 212,
          column: 8
        },
        end: {
          line: 212,
          column: 14
        }
      },
      '144': {
        start: {
          line: 214,
          column: 8
        },
        end: {
          line: 214,
          column: 72
        }
      },
      '145': {
        start: {
          line: 215,
          column: 8
        },
        end: {
          line: 215,
          column: 14
        }
      },
      '146': {
        start: {
          line: 217,
          column: 8
        },
        end: {
          line: 217,
          column: 39
        }
      },
      '147': {
        start: {
          line: 219,
          column: 4
        },
        end: {
          line: 219,
          column: 40
        }
      },
      '148': {
        start: {
          line: 220,
          column: 4
        },
        end: {
          line: 220,
          column: 35
        }
      },
      '149': {
        start: {
          line: 221,
          column: 4
        },
        end: {
          line: 221,
          column: 67
        }
      },
      '150': {
        start: {
          line: 222,
          column: 4
        },
        end: {
          line: 222,
          column: 66
        }
      },
      '151': {
        start: {
          line: 223,
          column: 4
        },
        end: {
          line: 223,
          column: 16
        }
      },
      '152': {
        start: {
          line: 225,
          column: 2
        },
        end: {
          line: 239,
          column: 4
        }
      },
      '153': {
        start: {
          line: 226,
          column: 4
        },
        end: {
          line: 228,
          column: 5
        }
      },
      '154': {
        start: {
          line: 227,
          column: 6
        },
        end: {
          line: 227,
          column: 49
        }
      },
      '155': {
        start: {
          line: 229,
          column: 4
        },
        end: {
          line: 231,
          column: 5
        }
      },
      '156': {
        start: {
          line: 230,
          column: 6
        },
        end: {
          line: 230,
          column: 55
        }
      },
      '157': {
        start: {
          line: 232,
          column: 4
        },
        end: {
          line: 234,
          column: 5
        }
      },
      '158': {
        start: {
          line: 233,
          column: 6
        },
        end: {
          line: 233,
          column: 54
        }
      },
      '159': {
        start: {
          line: 235,
          column: 4
        },
        end: {
          line: 237,
          column: 5
        }
      },
      '160': {
        start: {
          line: 236,
          column: 6
        },
        end: {
          line: 236,
          column: 57
        }
      },
      '161': {
        start: {
          line: 238,
          column: 4
        },
        end: {
          line: 238,
          column: 16
        }
      },
      '162': {
        start: {
          line: 240,
          column: 2
        },
        end: {
          line: 273,
          column: 4
        }
      },
      '163': {
        start: {
          line: 241,
          column: 4
        },
        end: {
          line: 241,
          column: 28
        }
      },
      '164': {
        start: {
          line: 242,
          column: 21
        },
        end: {
          line: 242,
          column: 62
        }
      },
      '165': {
        start: {
          line: 243,
          column: 4
        },
        end: {
          line: 246,
          column: 5
        }
      },
      '166': {
        start: {
          line: 244,
          column: 6
        },
        end: {
          line: 244,
          column: 54
        }
      },
      '167': {
        start: {
          line: 245,
          column: 6
        },
        end: {
          line: 245,
          column: 13
        }
      },
      '168': {
        start: {
          line: 247,
          column: 21
        },
        end: {
          line: 247,
          column: 100
        }
      },
      '169': {
        start: {
          line: 248,
          column: 4
        },
        end: {
          line: 271,
          column: 7
        }
      },
      '170': {
        start: {
          line: 249,
          column: 18
        },
        end: {
          line: 249,
          column: 20
        }
      },
      '171': {
        start: {
          line: 250,
          column: 6
        },
        end: {
          line: 264,
          column: 7
        }
      },
      '172': {
        start: {
          line: 251,
          column: 8
        },
        end: {
          line: 253,
          column: 9
        }
      },
      '173': {
        start: {
          line: 252,
          column: 10
        },
        end: {
          line: 252,
          column: 63
        }
      },
      '174': {
        start: {
          line: 254,
          column: 13
        },
        end: {
          line: 264,
          column: 7
        }
      },
      '175': {
        start: {
          line: 255,
          column: 8
        },
        end: {
          line: 257,
          column: 9
        }
      },
      '176': {
        start: {
          line: 256,
          column: 10
        },
        end: {
          line: 256,
          column: 78
        }
      },
      '177': {
        start: {
          line: 258,
          column: 8
        },
        end: {
          line: 260,
          column: 9
        }
      },
      '178': {
        start: {
          line: 259,
          column: 10
        },
        end: {
          line: 259,
          column: 79
        }
      },
      '179': {
        start: {
          line: 261,
          column: 8
        },
        end: {
          line: 263,
          column: 9
        }
      },
      '180': {
        start: {
          line: 262,
          column: 10
        },
        end: {
          line: 262,
          column: 158
        }
      },
      '181': {
        start: {
          line: 265,
          column: 6
        },
        end: {
          line: 268,
          column: 7
        }
      },
      '182': {
        start: {
          line: 266,
          column: 8
        },
        end: {
          line: 266,
          column: 33
        }
      },
      '183': {
        start: {
          line: 267,
          column: 8
        },
        end: {
          line: 267,
          column: 15
        }
      },
      '184': {
        start: {
          line: 269,
          column: 6
        },
        end: {
          line: 269,
          column: 25
        }
      },
      '185': {
        start: {
          line: 270,
          column: 6
        },
        end: {
          line: 270,
          column: 34
        }
      },
      '186': {
        start: {
          line: 272,
          column: 4
        },
        end: {
          line: 272,
          column: 40
        }
      },
      '187': {
        start: {
          line: 274,
          column: 2
        },
        end: {
          line: 276,
          column: 4
        }
      },
      '188': {
        start: {
          line: 275,
          column: 4
        },
        end: {
          line: 275,
          column: 40
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 1,
            column: 54
          },
          end: {
            line: 1,
            column: 55
          }
        },
        loc: {
          start: {
            line: 1,
            column: 179
          },
          end: {
            line: 192,
            column: 1
          }
        },
        line: 1
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 9,
            column: 26
          },
          end: {
            line: 9,
            column: 27
          }
        },
        loc: {
          start: {
            line: 9,
            column: 38
          },
          end: {
            line: 23,
            column: 3
          }
        },
        line: 9
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 24,
            column: 28
          },
          end: {
            line: 24,
            column: 29
          }
        },
        loc: {
          start: {
            line: 24,
            column: 40
          },
          end: {
            line: 46,
            column: 3
          }
        },
        line: 24
      },
      '3': {
        name: '(anonymous_3)',
        decl: {
          start: {
            line: 32,
            column: 294
          },
          end: {
            line: 32,
            column: 295
          }
        },
        loc: {
          start: {
            line: 32,
            column: 302
          },
          end: {
            line: 45,
            column: 5
          }
        },
        line: 32
      },
      '4': {
        name: '(anonymous_4)',
        decl: {
          start: {
            line: 47,
            column: 20
          },
          end: {
            line: 47,
            column: 21
          }
        },
        loc: {
          start: {
            line: 47,
            column: 49
          },
          end: {
            line: 52,
            column: 3
          }
        },
        line: 47
      },
      '5': {
        name: '(anonymous_5)',
        decl: {
          start: {
            line: 49,
            column: 115
          },
          end: {
            line: 49,
            column: 116
          }
        },
        loc: {
          start: {
            line: 49,
            column: 123
          },
          end: {
            line: 51,
            column: 5
          }
        },
        line: 49
      },
      '6': {
        name: '(anonymous_6)',
        decl: {
          start: {
            line: 53,
            column: 22
          },
          end: {
            line: 53,
            column: 23
          }
        },
        loc: {
          start: {
            line: 53,
            column: 38
          },
          end: {
            line: 61,
            column: 3
          }
        },
        line: 53
      },
      '7': {
        name: '(anonymous_7)',
        decl: {
          start: {
            line: 62,
            column: 35
          },
          end: {
            line: 62,
            column: 36
          }
        },
        loc: {
          start: {
            line: 62,
            column: 51
          },
          end: {
            line: 87,
            column: 3
          }
        },
        line: 62
      },
      '8': {
        name: '(anonymous_8)',
        decl: {
          start: {
            line: 71,
            column: 62
          },
          end: {
            line: 71,
            column: 63
          }
        },
        loc: {
          start: {
            line: 71,
            column: 70
          },
          end: {
            line: 73,
            column: 5
          }
        },
        line: 71
      },
      '9': {
        name: '(anonymous_9)',
        decl: {
          start: {
            line: 88,
            column: 29
          },
          end: {
            line: 88,
            column: 30
          }
        },
        loc: {
          start: {
            line: 88,
            column: 45
          },
          end: {
            line: 156,
            column: 3
          }
        },
        line: 88
      },
      '10': {
        name: '(anonymous_10)',
        decl: {
          start: {
            line: 157,
            column: 31
          },
          end: {
            line: 157,
            column: 32
          }
        },
        loc: {
          start: {
            line: 157,
            column: 47
          },
          end: {
            line: 186,
            column: 3
          }
        },
        line: 157
      },
      '11': {
        name: '(anonymous_11)',
        decl: {
          start: {
            line: 169,
            column: 7
          },
          end: {
            line: 169,
            column: 8
          }
        },
        loc: {
          start: {
            line: 169,
            column: 20
          },
          end: {
            line: 185,
            column: 5
          }
        },
        line: 169
      },
      '12': {
        name: '(anonymous_12)',
        decl: {
          start: {
            line: 187,
            column: 31
          },
          end: {
            line: 187,
            column: 32
          }
        },
        loc: {
          start: {
            line: 187,
            column: 47
          },
          end: {
            line: 191,
            column: 3
          }
        },
        line: 187
      },
      '13': {
        name: 'PlanIndicateurCtrl_edit',
        decl: {
          start: {
            line: 193,
            column: 9
          },
          end: {
            line: 193,
            column: 32
          }
        },
        loc: {
          start: {
            line: 193,
            column: 119
          },
          end: {
            line: 277,
            column: 1
          }
        },
        line: 193
      },
      '14': {
        name: '(anonymous_14)',
        decl: {
          start: {
            line: 195,
            column: 23
          },
          end: {
            line: 195,
            column: 24
          }
        },
        loc: {
          start: {
            line: 195,
            column: 46
          },
          end: {
            line: 224,
            column: 3
          }
        },
        line: 195
      },
      '15': {
        name: '(anonymous_15)',
        decl: {
          start: {
            line: 225,
            column: 28
          },
          end: {
            line: 225,
            column: 29
          }
        },
        loc: {
          start: {
            line: 225,
            column: 44
          },
          end: {
            line: 239,
            column: 3
          }
        },
        line: 225
      },
      '16': {
        name: '(anonymous_16)',
        decl: {
          start: {
            line: 240,
            column: 24
          },
          end: {
            line: 240,
            column: 25
          }
        },
        loc: {
          start: {
            line: 240,
            column: 40
          },
          end: {
            line: 273,
            column: 3
          }
        },
        line: 240
      },
      '17': {
        name: '(anonymous_17)',
        decl: {
          start: {
            line: 248,
            column: 112
          },
          end: {
            line: 248,
            column: 113
          }
        },
        loc: {
          start: {
            line: 248,
            column: 120
          },
          end: {
            line: 271,
            column: 5
          }
        },
        line: 248
      },
      '18': {
        name: '(anonymous_18)',
        decl: {
          start: {
            line: 274,
            column: 22
          },
          end: {
            line: 274,
            column: 23
          }
        },
        loc: {
          start: {
            line: 274,
            column: 34
          },
          end: {
            line: 276,
            column: 3
          }
        },
        line: 274
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 13,
            column: 4
          },
          end: {
            line: 15,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 13,
            column: 4
          },
          end: {
            line: 15,
            column: 5
          }
        }, {
          start: {
            line: 13,
            column: 4
          },
          end: {
            line: 15,
            column: 5
          }
        }],
        line: 13
      },
      '1': {
        loc: {
          start: {
            line: 17,
            column: 4
          },
          end: {
            line: 19,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 17,
            column: 4
          },
          end: {
            line: 19,
            column: 5
          }
        }, {
          start: {
            line: 17,
            column: 4
          },
          end: {
            line: 19,
            column: 5
          }
        }],
        line: 17
      },
      '2': {
        loc: {
          start: {
            line: 27,
            column: 4
          },
          end: {
            line: 29,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 27,
            column: 4
          },
          end: {
            line: 29,
            column: 5
          }
        }, {
          start: {
            line: 27,
            column: 4
          },
          end: {
            line: 29,
            column: 5
          }
        }],
        line: 27
      },
      '3': {
        loc: {
          start: {
            line: 32,
            column: 50
          },
          end: {
            line: 32,
            column: 121
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 32,
            column: 71
          },
          end: {
            line: 32,
            column: 91
          }
        }, {
          start: {
            line: 32,
            column: 94
          },
          end: {
            line: 32,
            column: 121
          }
        }],
        line: 32
      },
      '4': {
        loc: {
          start: {
            line: 34,
            column: 8
          },
          end: {
            line: 38,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 34,
            column: 8
          },
          end: {
            line: 38,
            column: 9
          }
        }, {
          start: {
            line: 34,
            column: 8
          },
          end: {
            line: 38,
            column: 9
          }
        }],
        line: 34
      },
      '5': {
        loc: {
          start: {
            line: 39,
            column: 26
          },
          end: {
            line: 39,
            column: 97
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 39,
            column: 47
          },
          end: {
            line: 39,
            column: 67
          }
        }, {
          start: {
            line: 39,
            column: 70
          },
          end: {
            line: 39,
            column: 97
          }
        }],
        line: 39
      },
      '6': {
        loc: {
          start: {
            line: 41,
            column: 28
          },
          end: {
            line: 41,
            column: 76
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 41,
            column: 54
          },
          end: {
            line: 41,
            column: 71
          }
        }, {
          start: {
            line: 41,
            column: 74
          },
          end: {
            line: 41,
            column: 76
          }
        }],
        line: 41
      },
      '7': {
        loc: {
          start: {
            line: 55,
            column: 44
          },
          end: {
            line: 55,
            column: 86
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 55,
            column: 67
          },
          end: {
            line: 55,
            column: 81
          }
        }, {
          start: {
            line: 55,
            column: 84
          },
          end: {
            line: 55,
            column: 86
          }
        }],
        line: 55
      },
      '8': {
        loc: {
          start: {
            line: 66,
            column: 6
          },
          end: {
            line: 69,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 66,
            column: 6
          },
          end: {
            line: 69,
            column: 7
          }
        }, {
          start: {
            line: 66,
            column: 6
          },
          end: {
            line: 69,
            column: 7
          }
        }],
        line: 66
      },
      '9': {
        loc: {
          start: {
            line: 74,
            column: 4
          },
          end: {
            line: 76,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 74,
            column: 4
          },
          end: {
            line: 76,
            column: 5
          }
        }, {
          start: {
            line: 74,
            column: 4
          },
          end: {
            line: 76,
            column: 5
          }
        }],
        line: 74
      },
      '10': {
        loc: {
          start: {
            line: 94,
            column: 4
          },
          end: {
            line: 100,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 94,
            column: 4
          },
          end: {
            line: 100,
            column: 5
          }
        }, {
          start: {
            line: 94,
            column: 4
          },
          end: {
            line: 100,
            column: 5
          }
        }],
        line: 94
      },
      '11': {
        loc: {
          start: {
            line: 97,
            column: 11
          },
          end: {
            line: 100,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 97,
            column: 11
          },
          end: {
            line: 100,
            column: 5
          }
        }, {
          start: {
            line: 97,
            column: 11
          },
          end: {
            line: 100,
            column: 5
          }
        }],
        line: 97
      },
      '12': {
        loc: {
          start: {
            line: 102,
            column: 4
          },
          end: {
            line: 104,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 102,
            column: 4
          },
          end: {
            line: 104,
            column: 5
          }
        }, {
          start: {
            line: 102,
            column: 4
          },
          end: {
            line: 104,
            column: 5
          }
        }],
        line: 102
      },
      '13': {
        loc: {
          start: {
            line: 107,
            column: 13
          },
          end: {
            line: 107,
            column: 81
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 107,
            column: 38
          },
          end: {
            line: 107,
            column: 68
          }
        }, {
          start: {
            line: 107,
            column: 71
          },
          end: {
            line: 107,
            column: 81
          }
        }],
        line: 107
      },
      '14': {
        loc: {
          start: {
            line: 108,
            column: 13
          },
          end: {
            line: 108,
            column: 79
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 108,
            column: 37
          },
          end: {
            line: 108,
            column: 66
          }
        }, {
          start: {
            line: 108,
            column: 69
          },
          end: {
            line: 108,
            column: 79
          }
        }],
        line: 108
      },
      '15': {
        loc: {
          start: {
            line: 114,
            column: 13
          },
          end: {
            line: 114,
            column: 56
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 114,
            column: 13
          },
          end: {
            line: 114,
            column: 22
          }
        }, {
          start: {
            line: 114,
            column: 26
          },
          end: {
            line: 114,
            column: 56
          }
        }],
        line: 114
      },
      '16': {
        loc: {
          start: {
            line: 116,
            column: 4
          },
          end: {
            line: 128,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 116,
            column: 4
          },
          end: {
            line: 128,
            column: 5
          }
        }, {
          start: {
            line: 116,
            column: 4
          },
          end: {
            line: 128,
            column: 5
          }
        }],
        line: 116
      },
      '17': {
        loc: {
          start: {
            line: 119,
            column: 8
          },
          end: {
            line: 123,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 119,
            column: 8
          },
          end: {
            line: 123,
            column: 9
          }
        }, {
          start: {
            line: 119,
            column: 8
          },
          end: {
            line: 123,
            column: 9
          }
        }],
        line: 119
      },
      '18': {
        loc: {
          start: {
            line: 125,
            column: 6
          },
          end: {
            line: 127,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 125,
            column: 6
          },
          end: {
            line: 127,
            column: 7
          }
        }, {
          start: {
            line: 125,
            column: 6
          },
          end: {
            line: 127,
            column: 7
          }
        }],
        line: 125
      },
      '19': {
        loc: {
          start: {
            line: 129,
            column: 4
          },
          end: {
            line: 142,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 129,
            column: 4
          },
          end: {
            line: 142,
            column: 5
          }
        }, {
          start: {
            line: 129,
            column: 4
          },
          end: {
            line: 142,
            column: 5
          }
        }],
        line: 129
      },
      '20': {
        loc: {
          start: {
            line: 133,
            column: 8
          },
          end: {
            line: 137,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 133,
            column: 8
          },
          end: {
            line: 137,
            column: 9
          }
        }, {
          start: {
            line: 133,
            column: 8
          },
          end: {
            line: 137,
            column: 9
          }
        }],
        line: 133
      },
      '21': {
        loc: {
          start: {
            line: 139,
            column: 6
          },
          end: {
            line: 141,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 139,
            column: 6
          },
          end: {
            line: 141,
            column: 7
          }
        }, {
          start: {
            line: 139,
            column: 6
          },
          end: {
            line: 141,
            column: 7
          }
        }],
        line: 139
      },
      '22': {
        loc: {
          start: {
            line: 143,
            column: 4
          },
          end: {
            line: 146,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 143,
            column: 4
          },
          end: {
            line: 146,
            column: 5
          }
        }, {
          start: {
            line: 143,
            column: 4
          },
          end: {
            line: 146,
            column: 5
          }
        }],
        line: 143
      },
      '23': {
        loc: {
          start: {
            line: 170,
            column: 6
          },
          end: {
            line: 172,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 170,
            column: 6
          },
          end: {
            line: 172,
            column: 7
          }
        }, {
          start: {
            line: 170,
            column: 6
          },
          end: {
            line: 172,
            column: 7
          }
        }],
        line: 170
      },
      '24': {
        loc: {
          start: {
            line: 183,
            column: 95
          },
          end: {
            line: 183,
            column: 116
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 183,
            column: 111
          },
          end: {
            line: 183,
            column: 112
          }
        }, {
          start: {
            line: 183,
            column: 115
          },
          end: {
            line: 183,
            column: 116
          }
        }],
        line: 183
      },
      '25': {
        loc: {
          start: {
            line: 196,
            column: 4
          },
          end: {
            line: 218,
            column: 5
          }
        },
        type: 'switch',
        locations: [{
          start: {
            line: 197,
            column: 6
          },
          end: {
            line: 204,
            column: 14
          }
        }, {
          start: {
            line: 205,
            column: 6
          },
          end: {
            line: 212,
            column: 14
          }
        }, {
          start: {
            line: 213,
            column: 6
          },
          end: {
            line: 215,
            column: 14
          }
        }, {
          start: {
            line: 216,
            column: 6
          },
          end: {
            line: 217,
            column: 39
          }
        }],
        line: 196
      },
      '26': {
        loc: {
          start: {
            line: 198,
            column: 8
          },
          end: {
            line: 200,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 198,
            column: 8
          },
          end: {
            line: 200,
            column: 9
          }
        }, {
          start: {
            line: 198,
            column: 8
          },
          end: {
            line: 200,
            column: 9
          }
        }],
        line: 198
      },
      '27': {
        loc: {
          start: {
            line: 206,
            column: 8
          },
          end: {
            line: 208,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 206,
            column: 8
          },
          end: {
            line: 208,
            column: 9
          }
        }, {
          start: {
            line: 206,
            column: 8
          },
          end: {
            line: 208,
            column: 9
          }
        }],
        line: 206
      },
      '28': {
        loc: {
          start: {
            line: 226,
            column: 4
          },
          end: {
            line: 228,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 226,
            column: 4
          },
          end: {
            line: 228,
            column: 5
          }
        }, {
          start: {
            line: 226,
            column: 4
          },
          end: {
            line: 228,
            column: 5
          }
        }],
        line: 226
      },
      '29': {
        loc: {
          start: {
            line: 226,
            column: 8
          },
          end: {
            line: 226,
            column: 39
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 226,
            column: 8
          },
          end: {
            line: 226,
            column: 19
          }
        }, {
          start: {
            line: 226,
            column: 23
          },
          end: {
            line: 226,
            column: 39
          }
        }],
        line: 226
      },
      '30': {
        loc: {
          start: {
            line: 229,
            column: 4
          },
          end: {
            line: 231,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 229,
            column: 4
          },
          end: {
            line: 231,
            column: 5
          }
        }, {
          start: {
            line: 229,
            column: 4
          },
          end: {
            line: 231,
            column: 5
          }
        }],
        line: 229
      },
      '31': {
        loc: {
          start: {
            line: 232,
            column: 4
          },
          end: {
            line: 234,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 232,
            column: 4
          },
          end: {
            line: 234,
            column: 5
          }
        }, {
          start: {
            line: 232,
            column: 4
          },
          end: {
            line: 234,
            column: 5
          }
        }],
        line: 232
      },
      '32': {
        loc: {
          start: {
            line: 235,
            column: 4
          },
          end: {
            line: 237,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 235,
            column: 4
          },
          end: {
            line: 237,
            column: 5
          }
        }, {
          start: {
            line: 235,
            column: 4
          },
          end: {
            line: 237,
            column: 5
          }
        }],
        line: 235
      },
      '33': {
        loc: {
          start: {
            line: 243,
            column: 4
          },
          end: {
            line: 246,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 243,
            column: 4
          },
          end: {
            line: 246,
            column: 5
          }
        }, {
          start: {
            line: 243,
            column: 4
          },
          end: {
            line: 246,
            column: 5
          }
        }],
        line: 243
      },
      '34': {
        loc: {
          start: {
            line: 250,
            column: 6
          },
          end: {
            line: 264,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 250,
            column: 6
          },
          end: {
            line: 264,
            column: 7
          }
        }, {
          start: {
            line: 250,
            column: 6
          },
          end: {
            line: 264,
            column: 7
          }
        }],
        line: 250
      },
      '35': {
        loc: {
          start: {
            line: 251,
            column: 8
          },
          end: {
            line: 253,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 251,
            column: 8
          },
          end: {
            line: 253,
            column: 9
          }
        }, {
          start: {
            line: 251,
            column: 8
          },
          end: {
            line: 253,
            column: 9
          }
        }],
        line: 251
      },
      '36': {
        loc: {
          start: {
            line: 254,
            column: 13
          },
          end: {
            line: 264,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 254,
            column: 13
          },
          end: {
            line: 264,
            column: 7
          }
        }, {
          start: {
            line: 254,
            column: 13
          },
          end: {
            line: 264,
            column: 7
          }
        }],
        line: 254
      },
      '37': {
        loc: {
          start: {
            line: 255,
            column: 8
          },
          end: {
            line: 257,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 255,
            column: 8
          },
          end: {
            line: 257,
            column: 9
          }
        }, {
          start: {
            line: 255,
            column: 8
          },
          end: {
            line: 257,
            column: 9
          }
        }],
        line: 255
      },
      '38': {
        loc: {
          start: {
            line: 255,
            column: 12
          },
          end: {
            line: 255,
            column: 46
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 255,
            column: 12
          },
          end: {
            line: 255,
            column: 27
          }
        }, {
          start: {
            line: 255,
            column: 31
          },
          end: {
            line: 255,
            column: 46
          }
        }],
        line: 255
      },
      '39': {
        loc: {
          start: {
            line: 258,
            column: 8
          },
          end: {
            line: 260,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 258,
            column: 8
          },
          end: {
            line: 260,
            column: 9
          }
        }, {
          start: {
            line: 258,
            column: 8
          },
          end: {
            line: 260,
            column: 9
          }
        }],
        line: 258
      },
      '40': {
        loc: {
          start: {
            line: 258,
            column: 12
          },
          end: {
            line: 258,
            column: 46
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 258,
            column: 12
          },
          end: {
            line: 258,
            column: 27
          }
        }, {
          start: {
            line: 258,
            column: 31
          },
          end: {
            line: 258,
            column: 46
          }
        }],
        line: 258
      },
      '41': {
        loc: {
          start: {
            line: 261,
            column: 8
          },
          end: {
            line: 263,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 261,
            column: 8
          },
          end: {
            line: 263,
            column: 9
          }
        }, {
          start: {
            line: 261,
            column: 8
          },
          end: {
            line: 263,
            column: 9
          }
        }],
        line: 261
      },
      '42': {
        loc: {
          start: {
            line: 261,
            column: 12
          },
          end: {
            line: 261,
            column: 46
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 261,
            column: 12
          },
          end: {
            line: 261,
            column: 27
          }
        }, {
          start: {
            line: 261,
            column: 31
          },
          end: {
            line: 261,
            column: 46
          }
        }],
        line: 261
      },
      '43': {
        loc: {
          start: {
            line: 262,
            column: 37
          },
          end: {
            line: 262,
            column: 98
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 262,
            column: 56
          },
          end: {
            line: 262,
            column: 75
          }
        }, {
          start: {
            line: 262,
            column: 78
          },
          end: {
            line: 262,
            column: 98
          }
        }],
        line: 262
      },
      '44': {
        loc: {
          start: {
            line: 265,
            column: 6
          },
          end: {
            line: 268,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 265,
            column: 6
          },
          end: {
            line: 268,
            column: 7
          }
        }, {
          start: {
            line: 265,
            column: 6
          },
          end: {
            line: 268,
            column: 7
          }
        }],
        line: 265
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0,
      '32': 0,
      '33': 0,
      '34': 0,
      '35': 0,
      '36': 0,
      '37': 0,
      '38': 0,
      '39': 0,
      '40': 0,
      '41': 0,
      '42': 0,
      '43': 0,
      '44': 0,
      '45': 0,
      '46': 0,
      '47': 0,
      '48': 0,
      '49': 0,
      '50': 0,
      '51': 0,
      '52': 0,
      '53': 0,
      '54': 0,
      '55': 0,
      '56': 0,
      '57': 0,
      '58': 0,
      '59': 0,
      '60': 0,
      '61': 0,
      '62': 0,
      '63': 0,
      '64': 0,
      '65': 0,
      '66': 0,
      '67': 0,
      '68': 0,
      '69': 0,
      '70': 0,
      '71': 0,
      '72': 0,
      '73': 0,
      '74': 0,
      '75': 0,
      '76': 0,
      '77': 0,
      '78': 0,
      '79': 0,
      '80': 0,
      '81': 0,
      '82': 0,
      '83': 0,
      '84': 0,
      '85': 0,
      '86': 0,
      '87': 0,
      '88': 0,
      '89': 0,
      '90': 0,
      '91': 0,
      '92': 0,
      '93': 0,
      '94': 0,
      '95': 0,
      '96': 0,
      '97': 0,
      '98': 0,
      '99': 0,
      '100': 0,
      '101': 0,
      '102': 0,
      '103': 0,
      '104': 0,
      '105': 0,
      '106': 0,
      '107': 0,
      '108': 0,
      '109': 0,
      '110': 0,
      '111': 0,
      '112': 0,
      '113': 0,
      '114': 0,
      '115': 0,
      '116': 0,
      '117': 0,
      '118': 0,
      '119': 0,
      '120': 0,
      '121': 0,
      '122': 0,
      '123': 0,
      '124': 0,
      '125': 0,
      '126': 0,
      '127': 0,
      '128': 0,
      '129': 0,
      '130': 0,
      '131': 0,
      '132': 0,
      '133': 0,
      '134': 0,
      '135': 0,
      '136': 0,
      '137': 0,
      '138': 0,
      '139': 0,
      '140': 0,
      '141': 0,
      '142': 0,
      '143': 0,
      '144': 0,
      '145': 0,
      '146': 0,
      '147': 0,
      '148': 0,
      '149': 0,
      '150': 0,
      '151': 0,
      '152': 0,
      '153': 0,
      '154': 0,
      '155': 0,
      '156': 0,
      '157': 0,
      '158': 0,
      '159': 0,
      '160': 0,
      '161': 0,
      '162': 0,
      '163': 0,
      '164': 0,
      '165': 0,
      '166': 0,
      '167': 0,
      '168': 0,
      '169': 0,
      '170': 0,
      '171': 0,
      '172': 0,
      '173': 0,
      '174': 0,
      '175': 0,
      '176': 0,
      '177': 0,
      '178': 0,
      '179': 0,
      '180': 0,
      '181': 0,
      '182': 0,
      '183': 0,
      '184': 0,
      '185': 0,
      '186': 0,
      '187': 0,
      '188': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0
    },
    b: {
      '0': [0, 0],
      '1': [0, 0],
      '2': [0, 0],
      '3': [0, 0],
      '4': [0, 0],
      '5': [0, 0],
      '6': [0, 0],
      '7': [0, 0],
      '8': [0, 0],
      '9': [0, 0],
      '10': [0, 0],
      '11': [0, 0],
      '12': [0, 0],
      '13': [0, 0],
      '14': [0, 0],
      '15': [0, 0],
      '16': [0, 0],
      '17': [0, 0],
      '18': [0, 0],
      '19': [0, 0],
      '20': [0, 0],
      '21': [0, 0],
      '22': [0, 0],
      '23': [0, 0],
      '24': [0, 0],
      '25': [0, 0, 0, 0],
      '26': [0, 0],
      '27': [0, 0],
      '28': [0, 0],
      '29': [0, 0],
      '30': [0, 0],
      '31': [0, 0],
      '32': [0, 0],
      '33': [0, 0],
      '34': [0, 0],
      '35': [0, 0],
      '36': [0, 0],
      '37': [0, 0],
      '38': [0, 0],
      '39': [0, 0],
      '40': [0, 0],
      '41': [0, 0],
      '42': [0, 0],
      '43': [0, 0],
      '44': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

cov_2nqpyt597g.s[0]++;
angular.module('app').controller('indicatorPlanCtrl', function ($scope, $deltahttp, SweetAlert, $deltaActor, $rootScope, $translate, $CRUDService, $log, $deltadate, $filter, $uibModal) {
  cov_2nqpyt597g.f[0]++;

  var PATHVP = (cov_2nqpyt597g.s[1]++, 'ValeursPossible');
  var PATHINDIC = (cov_2nqpyt597g.s[2]++, 'DecoupageIndic');
  var LISTFLAG = (cov_2nqpyt597g.s[3]++, $rootScope.getCurrentProject().project.getFlag());
  cov_2nqpyt597g.s[4]++;
  $scope.planParams = {
    yearPlanSelected: null,
    periodPlanSelected: null
  };
  cov_2nqpyt597g.s[5]++;
  $scope.yearPlanChange = function () {
    cov_2nqpyt597g.f[1]++;
    cov_2nqpyt597g.s[6]++;

    $scope.beginEditPlan = false;
    cov_2nqpyt597g.s[7]++;
    $scope.listPeriodPlan = [];
    cov_2nqpyt597g.s[8]++;
    $scope.periodPlanSelected = null;
    cov_2nqpyt597g.s[9]++;
    if (!$scope.planParams.yearPlanSelected) {
      cov_2nqpyt597g.b[0][0]++;
      cov_2nqpyt597g.s[10]++;

      return;
    } else {
      cov_2nqpyt597g.b[0][1]++;
    }
    var year = (cov_2nqpyt597g.s[11]++, $scope.planParams.yearPlanSelected.id);
    cov_2nqpyt597g.s[12]++;
    if (!year) {
      cov_2nqpyt597g.b[1][0]++;
      cov_2nqpyt597g.s[13]++;

      return;
    } else {
      cov_2nqpyt597g.b[1][1]++;
    }
    cov_2nqpyt597g.s[14]++;
    $scope.listPeriodPlan = $deltadate.getYearPeriod(year, $scope.selectedItem.PERIOD_INDIC);
    cov_2nqpyt597g.s[15]++;
    $scope.planParams.periodPlanSelected = $scope.listPeriodPlan[0];
    cov_2nqpyt597g.s[16]++;
    $scope.periodPlanChange();
  };
  cov_2nqpyt597g.s[17]++;
  $scope.periodPlanChange = function () {
    cov_2nqpyt597g.f[2]++;
    cov_2nqpyt597g.s[18]++;

    $scope.relevResul = [];
    var period = (cov_2nqpyt597g.s[19]++, $scope.planParams.periodPlanSelected);
    cov_2nqpyt597g.s[20]++;
    if (!period) {
      cov_2nqpyt597g.b[2][0]++;
      cov_2nqpyt597g.s[21]++;

      return;
    } else {
      cov_2nqpyt597g.b[2][1]++;
    }
    cov_2nqpyt597g.s[22]++;
    $scope.beginEditPlan = false;
    cov_2nqpyt597g.s[23]++;
    $scope.isloading = true;
    cov_2nqpyt597g.s[24]++;
    $CRUDService.getAll(PATHINDIC, { get: '7', cl: $scope.home.byplan ? (cov_2nqpyt597g.b[3][0]++, $scope.selectedPL.id) : (cov_2nqpyt597g.b[3][1]++, $scope.selectedItem.CODE_CL), indic: $scope.selectedItem.id, ng: $scope.selectedItem.CODE_NG, dated: $deltadate.format(period.begin, 'yyyy-mm-dd'), datef: $deltadate.format(period.end, 'yyyy-mm-dd') }, function (data) {
      cov_2nqpyt597g.f[3]++;
      cov_2nqpyt597g.s[25]++;

      for (var i = data.length - 1; i >= 0; i--) {
        cov_2nqpyt597g.s[26]++;

        if (!data[i].id) {
          cov_2nqpyt597g.b[4][0]++;
          cov_2nqpyt597g.s[27]++;

          data[i].ANNEE_DECOUP = period.year;
          cov_2nqpyt597g.s[28]++;
          data[i].NUM_DECOUP = period.index;
          cov_2nqpyt597g.s[29]++;
          data[i].ID_INDIC = $scope.selectedItem.id;
        } else {
          cov_2nqpyt597g.b[4][1]++;
        }
        cov_2nqpyt597g.s[30]++;
        data[i].CODE_CL = $scope.home.byplan ? (cov_2nqpyt597g.b[5][0]++, $scope.selectedPL.id) : (cov_2nqpyt597g.b[5][1]++, $scope.selectedItem.CODE_CL);
        cov_2nqpyt597g.s[31]++;
        data[i].edit = false;
        cov_2nqpyt597g.s[32]++;
        data[i].IDACTEURS = eval(data[i].IDACTEURS) ? (cov_2nqpyt597g.b[6][0]++, data[i].IDACTEURS) : (cov_2nqpyt597g.b[6][1]++, -1);
      }
      cov_2nqpyt597g.s[33]++;
      $scope.relevResul = data;
      cov_2nqpyt597g.s[34]++;
      $scope.isloading = false;
    });
  };
  cov_2nqpyt597g.s[35]++;
  $scope.lockData = function (item, value, type) {
    cov_2nqpyt597g.f[4]++;
    cov_2nqpyt597g.s[36]++;

    $scope.isloading = true;
    cov_2nqpyt597g.s[37]++;
    $CRUDService.save(PATHINDIC, { action: 'validate_data', item: $filter('json')(item), id: item.id, type: type, value: value }, function (data) {
      cov_2nqpyt597g.f[5]++;
      cov_2nqpyt597g.s[38]++;

      $scope.periodPlanChange();
    });
  };
  cov_2nqpyt597g.s[39]++;
  $scope.updatePlan = function (item) {
    cov_2nqpyt597g.f[6]++;
    cov_2nqpyt597g.s[40]++;

    $scope.itemSelectedPlanEdit.id = item.id;
    cov_2nqpyt597g.s[41]++;
    $scope.itemSelectedPlanEdit.IDACTEURS = eval(item.IDACTEURS) ? (cov_2nqpyt597g.b[7][0]++, item.IDACTEURS) : (cov_2nqpyt597g.b[7][1]++, -1);
    cov_2nqpyt597g.s[42]++;
    $scope.itemSelectedPlanEdit.VALEUR_PREVU = item.VALEUR_PREVU;
    cov_2nqpyt597g.s[43]++;
    $scope.itemSelectedPlanEdit.DATE_ALERT = item.DATE_ALERT;
    cov_2nqpyt597g.s[44]++;
    $scope.itemSelectedPlanEdit.Date_Releve = item.Date_Releve;
    cov_2nqpyt597g.s[45]++;
    $scope.itemSelectedPlanEdit.Mon_code_prevue = item.Mon_code_prevue;
    cov_2nqpyt597g.s[46]++;
    $scope.itemSelectedPlanEdit.COUT_PREVU_INDIC = item.COUT_PREVU_INDIC;
  };
  cov_2nqpyt597g.s[47]++;
  $scope.initDecoupageIndicateur = function (item) {
    cov_2nqpyt597g.f[7]++;
    cov_2nqpyt597g.s[48]++;

    $scope.planParams.yearPlanSelected = null;
    cov_2nqpyt597g.s[49]++;
    $scope.selectedItemUnit = null;
    cov_2nqpyt597g.s[50]++;
    for (var _iterator = $scope.listData_unites_bksb, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
      var _ref;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref = _i.value;
      }

      var el = _ref;
      cov_2nqpyt597g.s[51]++;

      if (el.id == item.ID_UNITE) {
        cov_2nqpyt597g.b[8][0]++;
        cov_2nqpyt597g.s[52]++;

        $scope.selectedItemUnit = el;
        cov_2nqpyt597g.s[53]++;
        break;
      } else {
        cov_2nqpyt597g.b[8][1]++;
      }
    }
    cov_2nqpyt597g.s[54]++;
    $CRUDService.getAll(PATHVP, { get: 'all', indic: item.id }, function (data) {
      cov_2nqpyt597g.f[8]++;
      cov_2nqpyt597g.s[55]++;

      $scope.listValeurPossible = data;
    });
    cov_2nqpyt597g.s[56]++;
    if ($scope.selectedItemUnit == null) {
      cov_2nqpyt597g.b[9][0]++;
      cov_2nqpyt597g.s[57]++;

      return;
    } else {
      cov_2nqpyt597g.b[9][1]++;
    }
    cov_2nqpyt597g.s[58]++;
    $scope.selectedItem = item;
    cov_2nqpyt597g.s[59]++;
    $scope.yearPlanSelected = null;
    cov_2nqpyt597g.s[60]++;
    $scope.periodPlanSelected = null;
    cov_2nqpyt597g.s[61]++;
    $scope.listYearPlan = [].concat($deltadate.getYearBetween(item.DEB_EVAL_INDIC, item.FIN_EVAL_INDIC));
    cov_2nqpyt597g.s[62]++;
    $scope.listPeriodPlan = [];
    cov_2nqpyt597g.s[63]++;
    $scope.relevResul = [];
    cov_2nqpyt597g.s[64]++;
    $scope.getGlobalValue(item);
    cov_2nqpyt597g.s[65]++;
    $scope.isplan = true;
    cov_2nqpyt597g.s[66]++;
    $scope.planParams.yearPlanSelected = $scope.listYearPlan[0];
    cov_2nqpyt597g.s[67]++;
    $scope.yearPlanChange();
  };
  cov_2nqpyt597g.s[68]++;
  $scope.editPlanification = function (item) {
    cov_2nqpyt597g.f[9]++;
    cov_2nqpyt597g.s[69]++;

    $scope.itemSelectedPlanEdit = item;
    cov_2nqpyt597g.s[70]++;
    $scope.templateEditPlan = '';
    var editTemplate = (cov_2nqpyt597g.s[71]++, '');
    var P_value = (cov_2nqpyt597g.s[72]++, item.VALEUR_PREVU);
    var R_value = (cov_2nqpyt597g.s[73]++, item.VALEUR_INDIC);
    cov_2nqpyt597g.s[74]++;
    if ($scope.selectedItemUnit.TYPE_UNITES == 3) {
      cov_2nqpyt597g.b[10][0]++;
      cov_2nqpyt597g.s[75]++;

      P_value = eval(item.Mon_code_prevue);
      cov_2nqpyt597g.s[76]++;
      R_value = eval(item.Mon_Code_Reel);
    } else {
        cov_2nqpyt597g.b[10][1]++;
        cov_2nqpyt597g.s[77]++;
        if ($scope.selectedItemUnit.TYPE_UNITES <= 4) {
          cov_2nqpyt597g.b[11][0]++;
          cov_2nqpyt597g.s[78]++;

          P_value = eval(item.VALEUR_PREVU);
          cov_2nqpyt597g.s[79]++;
          R_value = eval(item.VALEUR_INDIC);
        } else {
          cov_2nqpyt597g.b[11][1]++;
        }
      }var period = (cov_2nqpyt597g.s[80]++, $scope.planParams.periodPlanSelected);
    cov_2nqpyt597g.s[81]++;
    if (!period) {
      cov_2nqpyt597g.b[12][0]++;
      cov_2nqpyt597g.s[82]++;

      return;
    } else {
      cov_2nqpyt597g.b[12][1]++;
    }
    var actors = (cov_2nqpyt597g.s[83]++, $filter('filter')($scope.listData_actors_bksb, { id: item.IDACTEURS }));
    cov_2nqpyt597g.s[84]++;
    $scope.editorPlan = Object.assign(angular.copy(item), {
      dateR: item.Date_Releve != '' ? (cov_2nqpyt597g.b[13][0]++, Date.newDate(item.Date_Releve)) : (cov_2nqpyt597g.b[13][1]++, period.end),
      dateA: item.DATE_ALERT != '' ? (cov_2nqpyt597g.b[14][0]++, Date.newDate(item.DATE_ALERT)) : (cov_2nqpyt597g.b[14][1]++, period.end),
      value: R_value,
      COMMENTS: item.COMMENTS,
      prevu: P_value,
      cout: eval(item.COUT_REEL_INDIC),
      budget: eval(item.COUT_PREVU_INDIC),
      actor: (cov_2nqpyt597g.b[15][0]++, actors[0]) || (cov_2nqpyt597g.b[15][1]++, $scope.listData_actors_bksb[1])
    });
    cov_2nqpyt597g.s[85]++;
    if ($scope.selectedItemUnit.TYPE_UNITES == 3) {
      cov_2nqpyt597g.b[16][0]++;

      var _find = (cov_2nqpyt597g.s[86]++, false);
      cov_2nqpyt597g.s[87]++;
      for (var _iterator2 = $scope.listValeurPossible, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
        var _ref2;

        if (_isArray2) {
          if (_i2 >= _iterator2.length) break;
          _ref2 = _iterator2[_i2++];
        } else {
          _i2 = _iterator2.next();
          if (_i2.done) break;
          _ref2 = _i2.value;
        }

        var el = _ref2;
        cov_2nqpyt597g.s[88]++;

        if (el.id == $scope.editorPlan.prevu) {
          cov_2nqpyt597g.b[17][0]++;
          cov_2nqpyt597g.s[89]++;

          _find = true;
          cov_2nqpyt597g.s[90]++;
          $scope.editorPlan.prevu = el;
          cov_2nqpyt597g.s[91]++;
          break;
        } else {
          cov_2nqpyt597g.b[17][1]++;
        }
      }
      cov_2nqpyt597g.s[92]++;
      if (!_find) {
        cov_2nqpyt597g.b[18][0]++;
        cov_2nqpyt597g.s[93]++;

        $scope.editorPlan.prevu = $scope.listValeurPossible[0];
      } else {
        cov_2nqpyt597g.b[18][1]++;
      }
    } else {
      cov_2nqpyt597g.b[16][1]++;
    }
    cov_2nqpyt597g.s[94]++;
    if ($scope.selectedItemUnit.TYPE_UNITES == 4) {
      cov_2nqpyt597g.b[19][0]++;
      cov_2nqpyt597g.s[95]++;

      editTemplate = '';
      cov_2nqpyt597g.s[96]++;
      for (var _iterator3 = $scope.indicateur.listValBool, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
        var _ref3;

        if (_isArray3) {
          if (_i3 >= _iterator3.length) break;
          _ref3 = _iterator3[_i3++];
        } else {
          _i3 = _iterator3.next();
          if (_i3.done) break;
          _ref3 = _i3.value;
        }

        var _el = _ref3;

        var _find2 = (cov_2nqpyt597g.s[97]++, false);
        cov_2nqpyt597g.s[98]++;
        if (_el.id == $scope.editorPlan.prevu) {
          cov_2nqpyt597g.b[20][0]++;
          cov_2nqpyt597g.s[99]++;

          $scope.editorPlan.prevu = _el;
          cov_2nqpyt597g.s[100]++;
          _find2 = true;
          cov_2nqpyt597g.s[101]++;
          break;
        } else {
          cov_2nqpyt597g.b[20][1]++;
        }
      }
      cov_2nqpyt597g.s[102]++;
      if (!find) {
        cov_2nqpyt597g.b[21][0]++;
        cov_2nqpyt597g.s[103]++;

        $scope.editorPlan.prevu = $scope.indicateur.listValBool[0];
      } else {
        cov_2nqpyt597g.b[21][1]++;
      }
    } else {
      cov_2nqpyt597g.b[19][1]++;
    }
    cov_2nqpyt597g.s[104]++;
    if ($scope.selectedItemUnit.TYPE_UNITES == 5) {
      cov_2nqpyt597g.b[22][0]++;
      cov_2nqpyt597g.s[105]++;

      $scope.editorPlan.prevu = Date.newDate($scope.editorPlan.prevu);
      cov_2nqpyt597g.s[106]++;
      editTemplate = '';
    } else {
      cov_2nqpyt597g.b[22][1]++;
    }
    cov_2nqpyt597g.s[107]++;
    $scope.templateEditPlan = editTemplate;
    cov_2nqpyt597g.s[108]++;
    $uibModal.open({
      templateUrl: 'app/views/indicator/planification/planification_edit.html',
      controller: PlanIndicateurCtrl_edit,
      scope: $scope,
      size: 'md_',
      backdrop: 'static',
      windowClass: 'animated fadeInRight left-modal '
    });
  };
  cov_2nqpyt597g.s[109]++;
  $scope.deletePlanification = function (item) {
    cov_2nqpyt597g.f[10]++;
    cov_2nqpyt597g.s[110]++;

    SweetAlert.swal({
      title: $translate.instant('COMMON.CONFIRM'),

      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#c8c8c8',

      confirmButtonText: $translate.instant('COMMON.NO'),
      cancelButtonText: $translate.instant('COMMON.YES'),
      closeOnConfirm: true,
      closeOnCancel: true
    }, function (isconfirm) {
      cov_2nqpyt597g.f[11]++;
      cov_2nqpyt597g.s[111]++;

      if (isconfirm) {
        cov_2nqpyt597g.b[23][0]++;
        cov_2nqpyt597g.s[112]++;

        return;
      } else {
        cov_2nqpyt597g.b[23][1]++;
      }
      cov_2nqpyt597g.s[113]++;
      item.VALEUR_PREVU = null;
      cov_2nqpyt597g.s[114]++;
      item.Mon_code_prevue = null;
      cov_2nqpyt597g.s[115]++;
      item.DATE_ALERT = '';
      cov_2nqpyt597g.s[116]++;
      item.Mon_code_prevue = null;
      cov_2nqpyt597g.s[117]++;
      item.COUT_PREVU_INDIC = 0;
      cov_2nqpyt597g.s[118]++;
      item.IDACTEURS = 0;
      cov_2nqpyt597g.s[119]++;
      item.Date_Releve = '';
      var itemSave = (cov_2nqpyt597g.s[120]++, angular.copy(item));
      cov_2nqpyt597g.s[121]++;
      itemSave.editor = null;
      cov_2nqpyt597g.s[122]++;
      itemSave.oldValue = null;
      cov_2nqpyt597g.s[123]++;
      $CRUDService.save(PATHINDIC, { action: 'delete', valeur: $filter('json')(itemSave), type: $scope.isplan ? (cov_2nqpyt597g.b[24][0]++, 0) : (cov_2nqpyt597g.b[24][1]++, 1) });
      cov_2nqpyt597g.s[124]++;
      item.flag = '255,255,255';
    });
  };
  cov_2nqpyt597g.s[125]++;
  $scope.cancelPlanification = function (item) {
    cov_2nqpyt597g.f[12]++;
    cov_2nqpyt597g.s[126]++;

    item.edit = false;
    cov_2nqpyt597g.s[127]++;
    $scope.beginEditPlan = false;
    cov_2nqpyt597g.s[128]++;
    item.editor = angular.copy(item.oldValue);
  };
});
function PlanIndicateurCtrl_edit($scope, $uibModalInstance, $deltadate, $rootScope, $CRUDService, $filter, $translate) {
  cov_2nqpyt597g.f[13]++;

  var PATHINDIC = (cov_2nqpyt597g.s[129]++, 'DecoupageIndic');
  cov_2nqpyt597g.s[130]++;
  $scope._changeItem = function (item, typeu) {
    cov_2nqpyt597g.f[14]++;
    cov_2nqpyt597g.s[131]++;

    switch (typeu) {
      case 3:
        cov_2nqpyt597g.b[25][0]++;
        cov_2nqpyt597g.s[132]++;

        if (!item.prevu.id) {
          cov_2nqpyt597g.b[26][0]++;
          cov_2nqpyt597g.s[133]++;

          return;
        } else {
          cov_2nqpyt597g.b[26][1]++;
        }
        cov_2nqpyt597g.s[134]++;
        item.VALEUR_PREVU = null;
        cov_2nqpyt597g.s[135]++;
        item.prevu = item.prevu.id;
        cov_2nqpyt597g.s[136]++;
        item.Mon_code_prevue = item.prevu;
        cov_2nqpyt597g.s[137]++;
        break;
      case 4:
        cov_2nqpyt597g.b[25][1]++;
        cov_2nqpyt597g.s[138]++;

        if (!item.prevu.id) {
          cov_2nqpyt597g.b[27][0]++;
          cov_2nqpyt597g.s[139]++;

          return;
        } else {
          cov_2nqpyt597g.b[27][1]++;
        }
        cov_2nqpyt597g.s[140]++;
        item.prevu = item.prevu.id;
        cov_2nqpyt597g.s[141]++;
        item.VALEUR_PREVU = item.prevu;
        cov_2nqpyt597g.s[142]++;
        item.Mon_code_prevue = null;
        cov_2nqpyt597g.s[143]++;
        break;
      case 5:
        cov_2nqpyt597g.b[25][2]++;
        cov_2nqpyt597g.s[144]++;

        item.VALEUR_PREVU = $deltadate.format(item.prevu, 'yyyy-mm-dd');
        cov_2nqpyt597g.s[145]++;
        break;
      default:
        cov_2nqpyt597g.b[25][3]++;
        cov_2nqpyt597g.s[146]++;

        item.VALEUR_PREVU = item.prevu;
    }
    cov_2nqpyt597g.s[147]++;
    item.COUT_PREVU_INDIC = item.budget;
    cov_2nqpyt597g.s[148]++;
    item.IDACTEURS = item.actor.id;
    cov_2nqpyt597g.s[149]++;
    item.Date_Releve = $deltadate.format(item.dateR, 'yyyy-mm-dd');
    cov_2nqpyt597g.s[150]++;
    item.DATE_ALERT = $deltadate.format(item.dateA, 'yyyy-mm-dd');
    cov_2nqpyt597g.s[151]++;
    return item;
  };
  cov_2nqpyt597g.s[152]++;
  $scope._checkValidation = function (item) {
    cov_2nqpyt597g.f[15]++;
    cov_2nqpyt597g.s[153]++;

    if ((cov_2nqpyt597g.b[29][0]++, !item.prevu) && (cov_2nqpyt597g.b[29][1]++, item.prevu !== 0)) {
      cov_2nqpyt597g.b[28][0]++;
      cov_2nqpyt597g.s[154]++;

      return 'INDICATOR.ERROR_DECOUP_PLAN.VALUE';
    } else {
      cov_2nqpyt597g.b[28][1]++;
    }
    cov_2nqpyt597g.s[155]++;
    if (!item.dateR) {
      cov_2nqpyt597g.b[30][0]++;
      cov_2nqpyt597g.s[156]++;

      return 'INDICATOR.ERROR_DECOUP_PLAN.DATE_RELEVE';
    } else {
      cov_2nqpyt597g.b[30][1]++;
    }
    cov_2nqpyt597g.s[157]++;
    if (!item.dateA) {
      cov_2nqpyt597g.b[31][0]++;
      cov_2nqpyt597g.s[158]++;

      return 'INDICATOR.ERROR_DECOUP_PLAN.DATE_ALERT';
    } else {
      cov_2nqpyt597g.b[31][1]++;
    }
    cov_2nqpyt597g.s[159]++;
    if ($deltadate.format(item.dateR, 'yyyy-mm-dd') < item.DATE_DECOUP) {
      cov_2nqpyt597g.b[32][0]++;
      cov_2nqpyt597g.s[160]++;

      return 'INDICATOR.ERROR_DECOUP_PLAN.DATE_RELEVE_T';
    } else {
      cov_2nqpyt597g.b[32][1]++;
    }
    cov_2nqpyt597g.s[161]++;
    return null;
  };
  cov_2nqpyt597g.s[162]++;
  $scope.ValidatePlan = function (item) {
    cov_2nqpyt597g.f[16]++;
    cov_2nqpyt597g.s[163]++;

    $scope.errorPlan = null;
    var strerror = (cov_2nqpyt597g.s[164]++, this._checkValidation(angular.copy(item)));
    cov_2nqpyt597g.s[165]++;
    if (strerror != null) {
      cov_2nqpyt597g.b[33][0]++;
      cov_2nqpyt597g.s[166]++;

      $scope.errorPlan = $translate.instant(strerror);
      cov_2nqpyt597g.s[167]++;
      return;
    } else {
      cov_2nqpyt597g.b[33][1]++;
    }
    var itemSave = (cov_2nqpyt597g.s[168]++, this._changeItem(angular.copy(item), eval($scope.selectedItemUnit.TYPE_UNITES)));
    cov_2nqpyt597g.s[169]++;
    $CRUDService.save(PATHINDIC, { action: 'MiseAJour', valeur: $filter('json')(itemSave), Master: 1, typeR: 0 }, function (data) {
      cov_2nqpyt597g.f[17]++;

      var error = (cov_2nqpyt597g.s[170]++, '');
      cov_2nqpyt597g.s[171]++;
      if (angular.isNumber(data)) {
        cov_2nqpyt597g.b[34][0]++;
        cov_2nqpyt597g.s[172]++;

        if (data < 1) {
          cov_2nqpyt597g.b[35][0]++;
          cov_2nqpyt597g.s[173]++;

          error = $translate.instant('INDICATOR.ERROR_UPDATE');
        } else {
          cov_2nqpyt597g.b[35][1]++;
        }
      } else {
          cov_2nqpyt597g.b[34][1]++;
          cov_2nqpyt597g.s[174]++;
          if (data.e == -66) {
            cov_2nqpyt597g.b[36][0]++;
            cov_2nqpyt597g.s[175]++;

            if ((cov_2nqpyt597g.b[38][0]++, data.l === null) && (cov_2nqpyt597g.b[38][1]++, data.g !== null)) {
              cov_2nqpyt597g.b[37][0]++;
              cov_2nqpyt597g.s[176]++;

              error = $translate.instant('INDICATOR.LESS_THAN', { valeur: data.g });
            } else {
              cov_2nqpyt597g.b[37][1]++;
            }
            cov_2nqpyt597g.s[177]++;
            if ((cov_2nqpyt597g.b[40][0]++, data.g === null) && (cov_2nqpyt597g.b[40][1]++, data.l !== null)) {
              cov_2nqpyt597g.b[39][0]++;
              cov_2nqpyt597g.s[178]++;

              error = $translate.instant('INDICATOR.GREAT_THAN', { valeur: data.l });
            } else {
              cov_2nqpyt597g.b[39][1]++;
            }
            cov_2nqpyt597g.s[179]++;
            if ((cov_2nqpyt597g.b[42][0]++, data.g !== null) && (cov_2nqpyt597g.b[42][1]++, data.l !== null)) {
              cov_2nqpyt597g.b[41][0]++;
              cov_2nqpyt597g.s[180]++;

              error = $translate.instant(data.g == data.l ? (cov_2nqpyt597g.b[43][0]++, 'INDICATOR.EGAL_TO') : (cov_2nqpyt597g.b[43][1]++, 'INDICATOR.BEETWEEB'), { valeur_min: data.l, valeur_max: data.g, valeur: data.g });
            } else {
              cov_2nqpyt597g.b[41][1]++;
            }
          } else {
            cov_2nqpyt597g.b[36][1]++;
          }
        }cov_2nqpyt597g.s[181]++;
      if (error != '') {
        cov_2nqpyt597g.b[44][0]++;
        cov_2nqpyt597g.s[182]++;

        $scope.errorPlan = error;
        cov_2nqpyt597g.s[183]++;
        return;
      } else {
        cov_2nqpyt597g.b[44][1]++;
      }
      cov_2nqpyt597g.s[184]++;
      itemSave.id = data;
      cov_2nqpyt597g.s[185]++;
      $scope.updatePlan(itemSave);
    });
    cov_2nqpyt597g.s[186]++;
    $uibModalInstance.dismiss('cancel');
  };
  cov_2nqpyt597g.s[187]++;
  $scope.closeModal = function () {
    cov_2nqpyt597g.f[18]++;
    cov_2nqpyt597g.s[188]++;

    $uibModalInstance.dismiss('cancel');
  };
}